import { images } from '.';

const speakers = [
    {
        id: 1,
        image: images.speaker1,
        name: "Liam Carter",
        title: "AI Engineer",
        biography: "Liam Carter is a forward-thinking AI engineer known for developing scalable, intelligent systems across industries. With a strong technical background, he specializes in real-time AI applications and smart automation. His focus lies in delivering cutting-edge engineering solutions powered by AI.",
        contacts: {
            phone: "555-234-7890",
            email: "liam.carter@example.com",
            website: "www.liamcarter.ai",
            company: "Carter AI Systems",
            experience: "10+ Years in AI Engineering"
        },
        accounts: {
            facebook: "/#",
            linkedin: "/#",
            twitter: "/#",
            instagram: "/#"
        },
        achievements: [
            "Top AI Engineer (2023)",
            "AI Systems Innovator Award (2022)",
            "Tech Excellence in Engineering (2021)"
        ],
        skills: [
            { id: 1, title: "AI System Design", progress: 94 },
            { id: 2, title: "Machine Learning", progress: 91 },
            { id: 3, title: "Automation Engineering", progress: 88 }
        ]
    },
    {
        id: 2,
        image: images.speaker2,
        name: "Ava Bennett",
        title: "AI Researcher",
        biography: "Ava Bennett is a dedicated AI researcher focused on pushing the boundaries of artificial intelligence through ethical innovation and deep learning. She’s known for her academic rigor and breakthrough work in natural language processing and cognitive AI systems.",
        contacts: {
            phone: "555-678-1245",
            email: "ava.bennett@example.com",
            website: "www.avabennett.ai",
            company: "NextMind Research",
            experience: "9+ Years in AI Research"
        },
        accounts: {
            facebook: "/#",
            linkedin: "/#",
            twitter: "/#",
            instagram: "/#"
        },
        achievements: [
            "Women in AI Award (2022)",
            "Pioneer in NLP Research (2021)",
            "Best Cognitive AI Study (2020)"
        ],
        skills: [
            { id: 1, title: "Deep Learning", progress: 93 },
            { id: 2, title: "NLP Research", progress: 90 },
            { id: 3, title: "AI Ethics", progress: 87 }
        ]
    },
    {
        id: 3,
        image: images.speaker3,
        name: "Ethan Brooks",
        title: "Tech Strategist",
        biography: "Ethan Brooks is a forward-thinking tech strategist who specializes in developing scalable digital frameworks and aligning AI innovations with long-term business goals. He has helped startups and enterprises navigate digital transformation with data-driven strategies.",
        contacts: {
            phone: "555-321-7789",
            email: "ethan.brooks@example.com",
            website: "www.ethanbrooks.tech",
            company: "Strategix Labs",
            experience: "10+ Years in Tech Strategy"
        },
        accounts: {
            facebook: "/#",
            linkedin: "/#",
            twitter: "/#",
            instagram: "/#"
        },
        achievements: [
            "Top Tech Visionary (2023)",
            "Digital Leadership Award (2021)",
            "AI Strategy Excellence (2020)"
        ],
        skills: [
            { id: 1, title: "Tech Strategy", progress: 94 },
            { id: 2, title: "AI Integration", progress: 91 },
            { id: 3, title: "Business Analysis", progress: 89 }
        ]
    },
    {
        id: 4,
        image: images.speaker4,
        name: "Chloe Martin",
        title: "Innovation Lead",
        biography: "Chloe Martin is an accomplished innovation lead known for driving cutting-edge initiatives in AI and emerging technologies. With a keen eye for future trends and creative leadership, she empowers teams to develop pioneering solutions across tech ecosystems.",
        contacts: {
            phone: "555-654-1122",
            email: "chloe.martin@example.com",
            website: "www.chloemartin.ai",
            company: "FutureTech Hub",
            experience: "9+ Years in Tech Innovation"
        },
        accounts: {
            facebook: "/#",
            linkedin: "/#",
            twitter: "/#",
            instagram: "/#"
        },
        achievements: [
            "Women in Tech Award (2023)",
            "Innovation Excellence Award (2022)",
            "Top 100 Innovators (2021)"
        ],
        skills: [
            { id: 1, title: "Creative Leadership", progress: 93 },
            { id: 2, title: "Trend Analysis", progress: 90 },
            { id: 3, title: "Tech Innovation", progress: 92 }
        ]
    },
    {
        id: 5,
        image: images.speaker5,
        name: "Noah Griffin",
        title: "Robotics Expert",
        biography: "Noah Griffin is a seasoned robotics expert specializing in automation systems and AI-driven robotics. With a background in mechanical engineering and years of experience in industrial innovation, he is known for designing intelligent machines that enhance productivity and precision.",
        contacts: {
            phone: "555-321-7788",
            email: "noah.griffin@example.com",
            website: "www.noahgriffinrobotics.com",
            company: "RoboTech Dynamics",
            experience: "11+ Years in Robotics Engineering"
        },
        accounts: {
            facebook: "/#",
            linkedin: "/#",
            twitter: "/#",
            instagram: "/#"
        },
        achievements: [
            "Robotics Excellence Award (2023)",
            "Top Innovator in Automation (2022)",
            "Best Industrial Robotics Design (2021)"
        ],
        skills: [
            { id: 1, title: "Automation Systems", progress: 94 },
            { id: 2, title: "AI Integration", progress: 91 },
            { id: 3, title: "Mechanical Design", progress: 89 }
        ]
    },
    {
        id: 6,
        image: images.speaker6,
        name: "Emma Foster",
        title: "Vision Specialist",
        biography: "Emma Foster is a skilled vision specialist with expertise in computer vision and image processing. She develops advanced visual recognition systems and works on integrating visual AI into real-world applications such as robotics, surveillance, and smart devices.",
        contacts: {
            phone: "555-243-6699",
            email: "emma.foster@example.com",
            website: "www.emmafostervision.com",
            company: "VisualCore AI",
            experience: "9+ Years in Vision Technology"
        },
        accounts: {
            facebook: "/#",
            linkedin: "/#",
            twitter: "/#",
            instagram: "/#"
        },
        achievements: [
            "Best Vision Tech Developer (2023)",
            "Top 100 Women in AI (2022)",
            "AI Image Processing Award (2021)"
        ],
        skills: [
            { id: 1, title: "Computer Vision", progress: 93 },
            { id: 2, title: "Image Processing", progress: 90 },
            { id: 3, title: "Pattern Recognition", progress: 88 }
        ]
    },
    {
        id: 7,
        image: images.speaker7,
        name: "Mason Hayes",
        title: "Data Scientist",
        biography: "Mason Hayes is a highly analytical data scientist who excels at transforming raw data into actionable insights. With strong skills in predictive modeling, big data analytics, and statistical computing, he helps organizations make data-driven decisions with confidence.",
        contacts: {
            phone: "555-728-1134",
            email: "mason.hayes@example.com",
            website: "www.masonhayesdata.com",
            company: "Insight Analytics Co.",
            experience: "10+ Years in Data Science"
        },
        accounts: {
            facebook: "/#",
            linkedin: "/#",
            twitter: "/#",
            instagram: "/#"
        },
        achievements: [
            "Top 10 Data Experts (2023)",
            "Data Analytics Impact Award (2022)",
            "Best Predictive Model Design (2021)"
        ],
        skills: [
            { id: 1, title: "Data Analysis", progress: 94 },
            { id: 2, title: "Machine Learning", progress: 91 },
            { id: 3, title: "Big Data Tools", progress: 89 }
        ]
    },
    {
        id: 8,
        image: images.speaker8,
        name: "Mia Coleman",
        title: "Machine Engineer",
        biography: "Mia Coleman is a dynamic machine engineer with deep expertise in mechanical design and AI-driven automation systems. She specializes in developing intelligent machines that enhance productivity and reliability across industrial applications.",
        contacts: {
            phone: "555-846-2279",
            email: "mia.coleman@example.com",
            website: "www.miacolemanengineer.com",
            company: "Smart Systems Inc.",
            experience: "9+ Years in Machine Engineering"
        },
        accounts: {
            facebook: "/#",
            linkedin: "/#",
            twitter: "/#",
            instagram: "/#"
        },
        achievements: [
            "Best Engineering Project (2023)",
            "Women in Tech Award (2022)",
            "AI Mechanical Design Excellence (2021)"
        ],
        skills: [
            { id: 1, title: "Mechanical Design", progress: 93 },
            { id: 2, title: "Automation Systems", progress: 90 },
            { id: 3, title: "AI Integration", progress: 88 }
        ]
    }

];

export default speakers;